import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getTitle, getKeyword, getSeoCategory } from '../selectors/app'
const mapStateToProps = createStructuredSelector({
  category: getSeoCategory,
  keyword: getKeyword,
  title: getTitle,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  category: string
  keyword: string
  title: string
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect